import axios from "./axios";
import {
  SensorCreateDto,
  SensorResponseDto,
} from "../components/common/ObjectTypes";
import { SensorSearchQueryType } from "../components/common/QueryTypes";

export async function getSensors(
  query: SensorSearchQueryType,
): Promise<{ sensors: SensorResponseDto[]; count: number }> {
  try {
    const resp = await axios.get("/sensors", {
      params: query,
    });
    return resp.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function getSensor(sensorId: number): Promise<SensorResponseDto> {
  try {
    const resp = await axios.get(`/sensors/${sensorId}`);
    return resp.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function createSensor(
  data: SensorCreateDto,
): Promise<SensorResponseDto> {
  try {
    const resp = await axios.post("/sensors", data);
    return resp.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function updateSensor(
  data: SensorCreateDto,
): Promise<SensorResponseDto> {
  try {
    const resp = await axios.put(`/sensors/${data.sensor_id}`, data);
    return resp.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function deleteSensor(sensorId: number): Promise<any> {
  try {
    const resp = await axios.delete(`/sensors/${sensorId}`);
    return resp.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
